import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { LoadAdditive } from 'app/core/model/load-additive';
import { Product } from 'app/core/model/product';
import { Utility } from 'app/core/utility';
import DataSource from 'devextreme/data/data_source';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-load-additive-dialog',
    template: ` <div class="modal-header">
            <h2 class="modal-title">{{ isNew ? 'Add' : 'Edit' }} Load Additive</h2>
        </div>
        <div class="modal-body">
            @if (loadAdditive) {
            <dx-form [formData]="loadAdditive" validationGroup="additiveValidationGroup">
                <dxi-item
                    dataField="productId"
                    editorType="dxSelectBox"
                    [editorOptions]="{ dataSource: productsDS, displayExpr: 'partNumber', valueExpr: 'id', onSelectionChanged: productChanged }"
                    [label]="{ text: 'Product' }"
                ></dxi-item>
                <dxi-item dataField="name" [editorOptions]="{ readOnly: true }"></dxi-item>
                <dxi-item dataField="price" editorType="dxNumberBox" [isRequired]="true"></dxi-item>
                <dxi-item dataField="loadYards" [label]="{ text: 'Quantity' }" [isRequired]="true"></dxi-item>
            </dx-form>
            }
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="save()">Save</button>
            <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
        </div>`,
    styles: [],
})
export class LoadAdditiveDialogComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    auth = inject(AuthService);
    appInfo = inject(AppInformationService);

    result = new Subject<{ success: boolean; value?: LoadAdditive }>();

    loadId: number;
    loadAdditive: LoadAdditive;
    isNew: boolean;
    productsDS: DataSource;
    products: Product[];
    processing: boolean;

    async ngOnInit() {
        await this.appInfo.pleaseWaitShow();
        if (!this.loadAdditive) {
            this.isNew = true;
            this.loadAdditive = this.uow.loadAdditives.createEntity({
                loadId: this.loadId,
                price: null,
                loadYards: null,
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            });
        }

        this.products = await this.uow.getProducts();
        this.productsDS = new DataSource({ store: this.products, paginate: true });
        await this.appInfo.pleaseWaitHide();
    }

    productChanged = (e: any) => {
        if (this.processing) return;

        const product = e.selectedItem as Product;
        this.loadAdditive.name = product?.description;
        this.loadAdditive.abbreviation = product?.partNumber;
        this.loadAdditive.price = product?.basePrice;
    };

    async save() {
        if (this.processing) return;
        this.processing = true;

        const success = Utility.valid('additiveValidationGroup');
        if (!success) {
            this.processing = false;
            return;
        }

        return this.result.next({ success: true, value: this.loadAdditive });
    }

    cancel() {
        if (this.processing) return;
        this.processing = true;

        this.loadAdditive.entityAspect.rejectChanges();
        return this.result.next({ success: false });
    }
}
